import * as React from "react"
import {ToggleButtonSeeker} from "@ui-seeker/core";

import {GROUPED_BY} from "@constants"
import {marketPositionTab} from "../@signals";


const GROUPED_TABS = [
	{ value: GROUPED_BY.SELLER, label: 'Seller' },
    { value: GROUPED_BY.RETAILER, label: 'Retailer' },
	{ value: GROUPED_BY.COUNTRY, label: 'Market' }
]

export default function MarketplacesGroupedByToggleButton() {
    return <ToggleButtonSeeker
        value={marketPositionTab.value}
        tabs={GROUPED_TABS}
        onChange={(_, newValue) => marketPositionTab.value = newValue}

    />
}